import SectionLabel from "@/components/base/SectionLabel";
import { caseStudiesData } from "@/mocks/caseStudiesData";

export default function CaseListSection() {
  const scrollTo = (anchor: string) => {
    const el = document.querySelector(anchor);
    if (el) {
      const offset = 100;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section id="case-list" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel
            label={caseStudiesData.caseList.label}
            className="mb-3"
          />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {caseStudiesData.caseList.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {caseStudiesData.caseList.cases.map((item, idx) => (
            <div
              key={item.id}
              className="reveal flex flex-col rounded-lg border border-background-200/70 bg-background-50 hover:border-primary-200/60 transition-all duration-300 overflow-hidden"
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="relative h-48 md:h-44 overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt=""
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-[11px] font-bold font-label">
                    CASE {item.id}
                  </span>
                </div>
              </div>

              <div className="flex flex-col flex-1 p-4 md:p-5">
                <span className="text-[10px] md:text-xs font-medium text-primary-600 tracking-wider uppercase mb-2 font-label">
                  {item.orgType}
                </span>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                  {item.summary}
                </p>

                <div className="flex flex-wrap gap-1.5 mb-3">
                  {item.relatedServices.map((svc) => (
                    <span
                      key={svc}
                      className="inline-block px-2 py-0.5 rounded-full text-[10px] md:text-xs text-foreground-600 bg-background-100 border border-background-200/70"
                    >
                      {svc}
                    </span>
                  ))}
                </div>

                <button
                  onClick={() => scrollTo(item.anchor)}
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap self-start"
                >
                  詳しく見る
                  <i className="ri-arrow-down-line" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}